<div>
  <app-pratica-title></app-pratica-title>
  <div style="width: 50%; margin-bottom: 45px;">
    <mat-progress-bar mode="determinate" [value]="praticaProgressService.total | async" class="status-bar">
    </mat-progress-bar>
    <div>
      <h2>{{percentage | async}}</h2>
    </div>
  </div>
</div>
